import createIcon from '../../createIcon';

/**
 * @component @name Shop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNi41VjQuNUMxNiAzLjM5IDE1LjExIDIuNSAxNCAyLjVIMTBDOC44OSAyLjUgOCAzLjM5IDggNC41VjYuNUgyVjE5LjVDMiAyMC42MSAyLjg5IDIxLjUgNCAyMS41SDIwQzIxLjExIDIxLjUgMjIgMjAuNjEgMjIgMTkuNVY2LjVIMTZaTTEwIDQuNUgxNFY2LjVIMTBWNC41Wk05IDE4LjVWOS41TDE2LjUgMTMuNUw5IDE4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Shop = createIcon('Shop', [
  [
    'path',
    {
      d: 'M16 6.5V4.5C16 3.39 15.11 2.5 14 2.5H10C8.89 2.5 8 3.39 8 4.5V6.5H2V19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V6.5H16ZM10 4.5H14V6.5H10V4.5ZM9 18.5V9.5L16.5 13.5L9 18.5Z',
      key: 'n1mxse',
    },
  ],
]);

export default Shop;
